import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ImageAlignmentLeftIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ImageAlignmentLeft",
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.56 29.94h24.88a1.426 1.426 0 1 0 .26-2.84H3.56a1.426 1.426 0 1 0-.26 2.84zm0-25.04h24.88c.81.02 1.48-.62 1.5-1.43-.03-.8-.69-1.44-1.5-1.42H3.56c-.8-.02-1.47.61-1.5 1.42.02.81.69 1.45 1.5 1.43m.06 3.73h11.41c.86 0 1.56.7 1.56 1.56V21.6c0 .86-.7 1.56-1.56 1.56H3.62c-.86 0-1.56-.7-1.56-1.56V10.19c0-.86.7-1.56 1.56-1.56m17.94 14.61h6.71c.86.06 1.6-.58 1.67-1.44-.08-.85-.82-1.48-1.67-1.42h-6.71c-.85-.07-1.6.56-1.68 1.42.07.86.82 1.51 1.68 1.44m0-5.92h6.71c.85.06 1.6-.58 1.67-1.43-.07-.85-.82-1.48-1.67-1.42h-6.71c-.85-.07-1.6.56-1.68 1.42.07.86.83 1.5 1.68 1.43m0-5.97h6.71c.84.06 1.58-.55 1.67-1.38a1.57 1.57 0 0 0-1.67-1.43h-6.71c-.86-.07-1.61.57-1.68 1.43.1.84.84 1.45 1.68 1.38"
    })
  }));
};